import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import AlertContext from '../../../../../Context/Alert/AlertContext'
import { BaseURL } from '../../../../../Files/BaseURL'
import SocketContext from '../../../../../Context/Socket/SocketContext';
import axios from 'axios';
import { FaFileAlt, FaFileImage, FaFileVideo, FaRegFilePdf, FaTimes } from 'react-icons/fa';
import { BsFiletypeDocx } from 'react-icons/bs';
import { MdFolderZip } from 'react-icons/md';


const PurchaseService = () => {
    const [Profile, setProfile] = useState(null)
    const [Portfolio, setPortfolio] = useState(null)
    const [message, setmessage] = useState('')
    const [Conversation, setConversation] = useState([])
    const [TotalPages, setTotalPages] = useState(null)
    const [Page, setPage] = useState(null)
    const [ChatFile, setChatFile] = useState(null)
    const [FileName, setFileName] = useState(null)
    const [UploadedFile, setUploadedFile] = useState(null)

    const { userid, marketid } = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    const alertcontext = useContext(AlertContext);
    const { showAlert } = alertcontext;

    const socketcontext = useContext(SocketContext);
    const { OnlineUsers, SocetConnection, isUserOnline } = socketcontext;


    const fetchPortfolio = async () => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/marektplace/Service/marketplacedetails/${userid}/${marketid}`, {
                headers: {
                    'auth-token': authToken,
                }
            });
            const data = await response.json();
            setProfile(data.User);
            setPortfolio(data.Portfolio)
        } catch (error) {
            showAlert('Error fetching Service Skills', 'danger');
        }
    };

    const fetchconversation = async () => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.get(`${BaseURL}/api/messaging/getMessagesbyuser/${userid}`, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'auth-token': authToken,
                }
            });
            if (response.data.success) {
                setConversation(response.data.messages)
                setTotalPages(response.data.totalPages)
                setPage(response.data.page)
            } else {
                if (response.data.sameuser) {
                    setConversation(null)
                } else {
                    showAlert(response.data.message, 'danger')
                }
            }
        } catch (error) {
            showAlert(error,'danger')
        }
    }

    useEffect(() => {
        if (SocetConnection) {
            const handleMessage = (data) => {
                navigate('/user-dashboard/chat');
            };

            // Attach the event handler
            SocetConnection.on('message', handleMessage);

            // Cleanup function to remove the event handler
            return () => {
                SocetConnection.off('message', handleMessage);
            };
        }
    }, [SocetConnection, location.search]);

    useEffect(() => {
        if (marketid) {
            fetchPortfolio()
            fetchconversation()
        }
    }, [marketid])

    const FetchChat = async () => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.get(`${BaseURL}/api/messaging/fetchchatid/${userid}`, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'auth-token': authToken,
                }
            })
            if (response.data.success) {
                navigate(`/user-dashboard/chat?user=${userid}&chatid=${response.data?.messagechat?._id}`)
            }
        } catch (error) {
            showAlert("Internal Server Error", 'danger')
        }
    }

    const handleSendMessage = async (e) => {
        if (userid) {
            if (message !== "") {
                if (SocetConnection) {
                    await SocetConnection.emit('new message', {
                        UserID: userid,
                        covnersation: message,
                        File: {
                            Link: UploadedFile,
                            Name: FileName
                        }
                    })
                    setmessage("")
                    setUploadedFile(null)
                    setFileName(null)
                    setChatFile(null)
                }
            }
        }
    }

    const FileUpload = async (e) => {
        try {
            const file = e.target.files[0];
            setChatFile(file);
            setFileName(file.name);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('filename', file.name);

            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/messaging/upload-docs`, {
                method: "POST",
                headers: {
                    'auth-token': authToken,
                },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                setUploadedFile(data?.location);
            } else {
                showAlert("File not uploaded, try again", 'danger');
            }
        } catch (error) {
            console.error("File upload error:", error);
            showAlert("File not uploaded, try again", 'danger');
        }
    };

    const renderFileIcon = (file) => {
        const fileType = file;
        switch (fileType) {
            case 'image':
                return <FaFileImage className='text-2xl w-full text-primarygreen' />;
            case 'video':
                return <FaFileVideo className='text-2xl w-full text-primarygreen' />;
            case 'pdf':
                return <FaRegFilePdf className='text-2xl w-full text-red-500' />;
            case 'application':
                return <FaRegFilePdf className='text-2xl w-full text-red-500' />;
            case 'doc':
                return <BsFiletypeDocx className='text-2xl w-full text-blue-500' />;
            case 'docx':
                return <BsFiletypeDocx className='text-2xl w-full text-blue-500' />;
            case 'zip':
                return <MdFolderZip className='text-2xl w-full text-gray-400' />;
            default:
                return <FaFileAlt className='text-2xl w-full text-primarygreen' />;
        }
    };


    return (
        <div className='flex items-center font-pop flex-col'>
            <div className="bg-white rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[50%] flex flex-col gap-4">
                <h1 className='font-semibold text-xl text-center'>Purchase service from</h1>
                <div className="flex font-pop items-center gap-2">
                    <div>
                        <img src={Profile?.ProfilePhoto} alt="" className='w-16 h-16 rounded-full' />
                    </div>
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-row gap-1 items-center">
                            <img src="../../../Assets/Prop/badge.png" className='w-6 h-6' />
                            <h4 className='text-base text-lightGrey'>Level {Profile?.Level}</h4>
                        </div>
                        <h3 className='text-lg md:text-xl font-semibold'>{Profile?.FirstName} {Profile?.LastName}</h3>
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-4">
                    <div className="flex items-center justify-center basis-[40%]">
                        <img src={Portfolio?.Images[0]?.img} alt="" className='h w-full rounded-2xl' />
                    </div>
                    <div className="flex flex-col gap-2 basis-[50%]">
                        <div className="flex font-pop flex-col gap-2 ">
                            <p className='text-base text-lightGrey font-light'>Service:</p>
                            <h3 className='text-xl font-medium'>{Portfolio?.Pacakage?.Title}</h3>
                        </div>
                        <div className="flex flex-row justify-between gap-2">
                            <div className="flex font-pop flex-col gap-2">
                                <p className='text-base text-lightGrey font-light'>Delivery time:</p>
                                <p className='text-base font-normal'>{Portfolio?.Pacakage?.Delivery}</p>
                            </div>
                            <div className="flex font-pop flex-col gap-2">
                                <p className='text-base text-lightGrey font-light'>Price:</p>
                                <h3 className='text-lg font-medium'>${Portfolio?.Pacakage?.Price}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                {Conversation !== null && <div className="border-2 border-light rounded-2xl py-2 px-2 md:px-4 flex flex-col justify-between">
                    <div className="flex flex-col gap-2 h-32 text-center">
                        <h3 className='font-pop text-lightGrey'>Please tell all what you need to the seller...</h3>
                    </div>
                    <div className="flex flex-row font-pop justify-between items-center bg-[#E8E8E8] rounded-3xl py-2 px-4">
                        <div className="flex w-[100%] flex-row items-center gap-2">
                            <label htmlFor="fileupload" className='relative'>
                                <img
                                    src="../../../../../../Assets/Prop/docattach.png"
                                    alt=""
                                    className='w-8 h-8'
                                />
                                <input
                                    type="file"
                                    id='fileupload'
                                    onChange={FileUpload}
                                    className='opacity-0 absolute'
                                />
                            </label>
                            <div className="flex gap-2 w-full">
                                {UploadedFile !== "" && UploadedFile !== null
                                    &&
                                    <div className="bg-gray-300 p-2 rounded shadow-md font-pop flex items-center">
                                        <div className="flex flex-col gap-2">
                                            {ChatFile && renderFileIcon(ChatFile)}
                                            <span className="ml-2 w-max text-xs">{FileName}</span>
                                        </div>
                                        <FaTimes
                                            className="ml-2 text-red-500 cursor-pointer"
                                            onClick={() => {
                                                setChatFile(null);
                                                setFileName(null);
                                                setUploadedFile(null);
                                            }}
                                        />
                                    </div>
                                }
                                <input
                                    type="text"
                                    value={message}
                                    onChange={(e) => { setmessage(e.target.value) }}
                                    placeholder='Message...'
                                    className='text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent'
                                />
                            </div>
                        </div>
                        <img
                            src="../../../../../Assets/Prop/messagesend.png"
                            alt=""
                            onClick={handleSendMessage}
                            className='w-6 h-6 cursor-pointer'
                        />
                    </div>
                </div>}
                {Conversation !== null && <button
                    className="my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full  text-white"
                    onClick={FetchChat}
                >
                    Purchase
                </button>}
            </div>
        </div>
    )
}

export default PurchaseService